import React, { FC, useEffect } from 'react';
import { Block as BlockModel, BlockWithNotes } from '../../../../config/api/models/Block';
import { GroupStudentSeriesScores } from '../../../../config/api/models/Score';
import { PageType, TrajectorySectionType } from '../../../../config/api/models/Trajectory';
import { BlocksList } from '../TrajectoryDetail';
import { useParams } from 'react-router';
import { UrlParams } from '../../../shared/types';
import { styled } from '@material-ui/core';

type TheoryOpbouwBlocksListProps = {
  blocks: BlockWithNotes[];
  pageId: string;
  type: PageType;
  trajectoryScoresByGroup?: GroupStudentSeriesScores;
  clusterId?: string;
};

const Wrapper = styled('div')({
  marginBottom: '3rem',
});

const TheoryOpbouwBlocksList: FC<TheoryOpbouwBlocksListProps> = ({
  blocks,
  pageId,
  type,
  trajectoryScoresByGroup,
  clusterId = undefined,
}) => {
  const { sectionCode } = useParams<UrlParams>();

  useEffect(() => {
    // @ts-ignore
    //com.wiris.js.JsPluginViewer.parseDocument(true);
  }, [sectionCode]);

  const filteredBlocks = React.useMemo(() => {
    if (!blocks || blocks.length === 0) return [];
    return blocks.filter((block: BlockModel) => block.content !== null || block.url !== null);
  }, [blocks]);

  return (
    <Wrapper>
      <BlocksList
        pageId={pageId}
        pageType={type as TrajectorySectionType}
        readOnly
        blocks={filteredBlocks}
        teacherProgressAndScores={trajectoryScoresByGroup}
        clusterId={clusterId}
      />
    </Wrapper>
  );
};

export default TheoryOpbouwBlocksList;
